export default {
  "nav": {
    "home": "Accueil",
    "telecom": "Télécommunication",
    "telecomInfrastructures": "Infrastructures",
    "telecomFibre": "Fibre Optique",
    "telecomMaintenance": "Maintenance",
    "genieCivilBTP": "Génie Civil & BTP",
    "solutions": "Solutions",
    "projets": "Projets",
    "aPropos": "À propos",
    "contact": "Contact",
    "getQuote": "Demander un devis"
  },
  "footer": {
    "telecomList": {
      "towers": "Tours & Pylônes",
      "fibre": "Fibre Optique",
      "maintenance": "Maintenance NOC"
    },
    "tagline": "Leader en infrastructures de télécommunication et solutions énergétiques depuis 2006. Nous connectons les communautés et alimentons le développement durable.",
    "subscribe": "S'inscrire",
    "subscribePlaceholder": "Votre email",
    "services": "Services",
    "servicesList": {
      "microgrids": "Micro-réseaux",
      "solarPumping": "Pompage solaire",
      "storage": "Stockage",
      "evCharging": "Recharge VE",
      "constructionMetal": "Construction Métallique & BTP",
      "itNetworks": "Informatique & Réseaux",
      "audit": "Audit et Conseils",
      "telecom": "Télécommunication",
      "transport": "Transport et Logistique",
      "expertise": "Expertise technique"
    },
    "company": "Entreprise",
    "companyList": {
      "about": "À propos",
      "projects": "Nos projets",
      "products": "Produits",
      "contact": "Contact"
    },
    "contact": "Contact",
    "copyright": "© 2026 IS TELECOM. Tous droits réservés.",
    "terms": "Conditions générales",
    "privacy": "Politique de confidentialité",
    "ctaTitle1": "Des infrastructures",
    "ctaTitle2": "de télécommunication & énergétiques",
    "ctaTitle3": "pour chaque région",
    "ctaButton": "Demander un devis"
  },
  "hero": {
    "badge": "{ ÉNERGIES & TÉLÉCOMMUNICATION }",
    "titleLine1": "Des solutions",
    "titleLine2": "énergétiques & de télécommunication",
    "titleLine3": "d'avenir",
    "subtitle": "Depuis 2006, IS TELECOM déploie des infrastructures de télécommunication et des solutions énergétiques dans 6 pays à travers l'Afrique.",
    "cta": "Demander un devis"
  },
  "overview": {
    "badge": "À Propos d'IS TELECOM",
    "titleLine1": "L'excellence dans",
    "titleLine2": "chaque projet d'infrastructure",
    "description": "Notre équipe multidisciplinaire combine expertise en télécommunication et énergétique pour fournir des solutions d'infrastructures fiables. De la tour de transmission au micro-réseau solaire, nous connectons les communautés et alimentons le développement durable.",
    "learnMore": "En savoir plus",
    "statYears": "Années d'expérience",
    "statCountries": "Pays desservis",
    "statProjects": "Projets réalisés"
  },
  "features": {
    "badge": "Fonctionnalités",
    "title": "Trois expertises, une mission : bâtir l'Afrique de demain",
    "items": [
      {"title": "Infrastructures Télécoms"},
      {"title": "Génie Civil & BTP"},
      {"title": "Solutions Énergétiques"}
    ]
  },
  "services": {
    "badge": "Nos Services",
    "title": "Des solutions adaptées à vos besoins",
    "description": "De l'énergie solaire à la télécommunication, en passant par la construction et le transport, notre expertise multidisciplinaire couvre l'ensemble de vos projets d'infrastructure.",
    "list": [
      {"title": "Évaluation Solaire", "tags": ["Solaire", "Consultation"]},
      {"title": "Installation de Panneaux", "tags": ["Solaire", "Installation"]},
      {"title": "Stockage par Batterie", "tags": ["Solaire", "Stockage"]},
      {"title": "Monitoring & Support", "tags": ["Solaire", "Monitoring"]},
      {"title": "Construction Métallique & BTP", "tags": ["BTP", "Construction"]},
      {"title": "Informatique & Réseaux", "tags": ["IT", "Réseaux"]},
      {"title": "Audit et Conseils", "tags": ["Audit", "Conseil"]},
      {"title": "Télécommunication", "tags": ["Télécom", "Infrastructure"]},
      {"title": "Transport et Logistique", "tags": ["Logistique", "Transport"]}
    ]
  },
  "projects": {
    "badge": "Nos Projets",
    "title": "Nos réalisations récentes",
    "viewDetails": "Voir les détails",
    "list": [
      {
        "category": "Micro-réseaux",
        "year": "2023",
        "title": "Village — Électrification Rurale",
        "description": "Un système solaire sur mesure qui réduit les coûts énergétiques et met l'énergie propre au service de votre communauté."
      },
      {
        "category": "Télécommunications",
        "year": "2025",
        "title": "Opérateur — Réseau Télécoms National",
        "description": "Déploiement d'infrastructures de télécommunication avec alimentation solaire pour 200 sites, assurant une connectivité fiable en zones rurales et urbaines."
      },
      {
        "category": "Monitoring",
        "year": "2024",
        "title": "Smart — Monitoring Avancé",
        "description": "Suivez les performances de votre système avec une installation solaire connectée qui vous aide à comprendre chaque kilowatt produit."
      }
    ]
  },
  "partners": {
    "badge": "Nos Partenaires",
    "title": "Ils nous font confiance",
    "description": "Des leaders mondiaux des télécommunications, de l'énergie et de la technologie collaborent avec IS TELECOM pour déployer des solutions durables à travers l'Afrique."
  },
  "process": {
    "badge": "Processus",
    "title": "De l'étude à la mise en service",
    "description": "Nous vous accompagnons de l'audit initial à la mise en service complète, que ce soit pour une infrastructure de télécommunication ou un projet énergétique.",
    "stepPrefix": "Étape",
    "steps": [
      {
        "title": "Étude & Ingénierie",
        "description": "Nous analysons vos besoins, étudions le terrain et concevons les plans d'ingénierie détaillés pour votre projet d'infrastructure."
      },
      {
        "title": "Construction & Installation",
        "description": "Nos équipes certifiées réalisent le génie civil, montent les structures et installent les équipements avec précision et sécurité."
      },
      {
        "title": "Tests & Mise en Service",
        "description": "Nous testons rigoureusement chaque composant, validons les performances et assurons la mise en service complète de votre infrastructure."
      }
    ]
  },
  "testimonials": {
    "badge": "Témoignages Clients",
    "titleLine1": "Des partenaires de confiance,",
    "titleLine2": "des infrastructures fiables",
    "verifiedReviews": "avis vérifiés",
    "items": [
      {
        "quote": "IS TELECOM a déployé plus de 200 sites pour notre réseau au Sénégal. Leur équipe maîtrise parfaitement les équipements Huawei et a respecté tous les délais, même dans les zones les plus difficiles d'accès.",
        "name": "Ahmadou Diallo",
        "role": "Directeur Réseau, MTN Sénégal"
      },
      {
        "quote": "La qualité de leur travail sur notre backbone fibre optique est remarquable. Tests OTDR impeccables, documentation complète, et une équipe qui connaît les standards Ericsson sur le bout des doigts.",
        "name": "Amina Diallo",
        "role": "Responsable Infrastructure, Orange CI"
      },
      {
        "quote": "Leur support NOC 24/7 fait toute la différence. Quand un site tombe à 3h du matin, l'équipe IS TELECOM est déjà sur place à 5h. Un niveau de réactivité qu'on ne trouve nulle part ailleurs.",
        "name": "Koffi Agbessi",
        "role": "Directeur Technique, Moov Africa"
      },
      {
        "quote": "Nous leur avons confié la modernisation 4G de 150 sites. Formation des équipes, installation, optimisation radio — tout a été livré dans les temps avec une qualité qui dépasse nos attentes.",
        "name": "Dr Fatou Beye",
        "role": "CTO, Airtel Sénégal"
      },
      {
        "quote": "IS TELECOM est notre partenaire de référence pour les pylônes. Leurs structures sont robustes, conformes aux normes antisismiques, et le génie civil est impeccable. Vraiment du travail de qualité.",
        "name": "Moussa Coulibaly",
        "role": "Responsable Déploiement, Vodacom"
      },
      {
        "quote": "Déploiement FTTH rapide et propre. En 3 mois, ils ont câblé toute notre zone métropolitaine. Leur maîtrise du GPON et leur gestion de projet sont impressionnantes.",
        "name": "Sophie Lawson",
        "role": "CEO, Togocom"
      }
    ]
  },
  "faq": {
    "badge": "FAQ",
    "title": "Questions fréquemment posées",
    "homeFaqs": [
      {"q": "01. Quels services de télécommunication propose IS TELECOM ?", "a": "Nous déployons des infrastructures de télécommunication complètes : tours et pylônes, réseaux fibre optique, maintenance d'équipements radio, et solutions de connectivité pour zones rurales et urbaines. Partenaires de Huawei, Ericsson et MTN, nous couvrons l'ensemble de la chaîne de télécommunication."},
      {"q": "02. Dans quels pays intervenez-vous ?", "a": "IS TELECOM est présent dans 6 pays d'Afrique de l'Ouest et de l'Est : Bénin, Togo, Mali, Zambie, Tanzanie et Sénégal. Nous avons des bureaux dans chacun de ces pays et y déployons des projets de télécommunication et énergétiques."},
      {"q": "03. Quels types de tours de télécommunication installez-vous ?", "a": "Nous concevons et installons tous types de pylônes : autostables (jusqu'à 120m), haubanés, monopôles urbains, et mâts tubulaires. Chaque installation respecte les normes internationales ANSI/TIA-222."},
      {"q": "04. Proposez-vous des contrats de maintenance de télécommunication ?", "a": "Absolument. Nos contrats de maintenance incluent des interventions préventives programmées, un support NOC 24/7, des interventions curatives sous 4h (SLA garanti), et la gestion complète des pièces de rechange."}
    ]
  },
  "contact": {
    "pageTitle": "Contactez-nous",
    "pageSubtitle": "Prêt à déployer votre infrastructure de télécommunication ou votre projet énergétique ? Notre équipe est là pour vous accompagner",
    "infoPhone": "Téléphone",
    "infoEmail": "Email",
    "infoAddress": "Adresse",
    "infoHours": "Horaires",
    "hoursLine1": "Lundi - Vendredi: 8h00 - 18h00",
    "hoursLine2": "Support NOC: 24/7",
    "formTitle": "Envoyez-nous un message",
    "formSubtitle": "Remplissez le formulaire ci-dessous et notre équipe vous répondra dans les 24 heures.",
    "formSuccess": "Message envoyé !",
    "formSuccessMsg": "Nous vous répondrons dans les plus brefs délais.",
    "labelName": "Nom complet",
    "placeholderName": "Votre nom et prénom",
    "labelEmail": "Email",
    "placeholderEmail": "votre@email.com",
    "labelPhone": "Téléphone",
    "placeholderPhone": "+229 XX XX XX XX",
    "labelSubject": "Sujet",
    "subjectOptions": {
      "info": "Information générale",
      "tech": "Information technique",
      "partnership": "Partenariat",
      "careers": "Carrières",
      "other": "Autre"
    },
    "labelMessage": "Message",
    "placeholderMessage": "Décrivez votre projet ou vos questions...",
    "sending": "Envoi en cours...",
    "send": "Envoyer le message",
    "quickResponse": "Besoin d'une réponse rapide ?",
    "freeQuote": "Devis gratuit :",
    "freeQuoteDesc": "Recevez une estimation sous 48h ouvrées pour tout projet d'infrastructure.",
    "techSupport": "Support technique :",
    "techSupportDesc": "Notre NOC est disponible 24/7 pour les clients en contrat de maintenance.",
    "siteVisit": "Visite sur site :",
    "siteVisitDesc": "Nous nous déplaçons gratuitement pour évaluer vos besoins en infrastructure.",
    "faqTitle": "Questions Fréquentes",
    "contactFaqs": [
      {"q": "Quel est le délai de déploiement d'un site de télécommunication ?", "a": "Pour un site standard, le délai est de 2 à 4 semaines après l'étude d'ingénierie. Pour les projets backbone fibre ou multi-sites, le planning est défini sur mesure selon l'ampleur du projet."},
      {"q": "Proposez-vous un service de maintenance de télécommunication ?", "a": "Oui, tous nos contrats incluent une maintenance préventive programmée et un support NOC 24/7 avec intervention garantie sous 4h. Nous proposons également des contrats de maintenance étendus."},
      {"q": "Quels sont les délais pour obtenir un devis ?", "a": "Nous vous envoyons un devis détaillé sous 48 heures ouvrées après réception de votre demande. Pour les projets complexes, une visite technique peut être nécessaire."},
      {"q": "Intervenez-vous en dehors de l'Afrique ?", "a": "Notre activité est concentrée sur 6 pays africains : Bénin, Togo, Mali, Zambie, Tanzanie et Sénégal. Cette présence ciblée nous permet d'offrir une expertise de proximité et une réactivité optimale sur chacun de ces marchés."},
      {"q": "Quelles certifications avez-vous ?", "a": "Nous sommes certifiés ISO 9001 et ISO 14001. Nos équipes sont formées et certifiées par Huawei, Ericsson et Nokia. Toutes nos installations respectent les normes ANSI/TIA-222."}
    ]
  },
  "devis": {
    "pageTitle": "Demandez votre devis personnalisé",
    "pageSubtitle": "Décrivez votre projet d'infrastructure de télécommunication ou énergétique et recevez une estimation détaillée sous 48 heures, sans engagement",
    "badge": "Devis gratuit",
    "advantages": [
      {"text": "Réponse sous 48h"},
      {"text": "Devis gratuit & sans engagement"},
      {"text": "Étude personnalisée par nos experts"},
      {"text": "Intervention dans 6 pays"}
    ],
    "step1Title": "Étape 1 : Vos informations",
    "step2Title": "Étape 2 : Votre projet",
    "step3Title": "Étape 3 : Récapitulatif",
    "labelName": "Nom complet",
    "labelCompany": "Entreprise / Organisation",
    "placeholderCompany": "Nom de votre entreprise",
    "labelEmail": "Email",
    "labelPhone": "Téléphone",
    "labelLocation": "Localisation du projet",
    "placeholderLocation": "Ville, Pays",
    "labelProjectType": "Type de projet",
    "selectProject": "Sélectionnez le type de projet",
    "labelBudget": "Budget estimé",
    "selectBudget": "Sélectionnez une fourchette",
    "labelTimeline": "Délai souhaité",
    "selectTimeline": "Sélectionnez un délai",
    "labelPower": "Détails techniques (optionnel)",
    "placeholderPower": "Ex: pylône 80m, backbone 200km, 50 sites de télécommunication...",
    "labelDescription": "Description du projet",
    "placeholderDescription": "Décrivez votre projet d'infrastructure, vos objectifs, vos contraintes techniques...",
    "continue": "Continuer",
    "back": "Retour",
    "send": "Envoyer la demande",
    "sending": "Envoi en cours...",
    "success": "Devis demandé avec succès !",
    "successMsg": "Notre équipe analyse votre projet et vous répondra sous 48 heures ouvrées avec une proposition détaillée.",
    "recapName": "Nom :",
    "recapCompany": "Entreprise :",
    "recapEmail": "Email :",
    "recapPhone": "Téléphone :",
    "recapProjectType": "Type de projet :",
    "recapLocation": "Localisation :",
    "recapBudget": "Budget :",
    "recapTimeline": "Délai :",
    "recapPower": "Détails techniques :",
    "recapDescription": "Description :",
    "projectTypes": [
      {"value": "micro-reseau", "label": "Micro-réseau solaire"},
      {"value": "pompage", "label": "Pompage solaire"},
      {"value": "stockage", "label": "Stockage d'énergie"},
      {"value": "recharge-ve", "label": "Recharge véhicules électriques"},
      {"value": "residentiel", "label": "Installation résidentielle"},
      {"value": "industriel", "label": "Installation industrielle"},
      {"value": "btp", "label": "Construction Métallique & BTP"},
      {"value": "informatique", "label": "Informatique (réseaux, serveurs)"},
      {"value": "audit", "label": "Audit et Conseils"},
      {"value": "telecom", "label": "Télécommunication (pylônes, fibre)"},
      {"value": "transport", "label": "Transport et Logistique"},
      {"value": "autre", "label": "Autre projet"}
    ],
    "budgets": [
      {"value": "", "label": "Sélectionnez une fourchette"},
      {"value": "moins-5k", "label": "Moins de 5 000 €"},
      {"value": "5k-20k", "label": "5 000 € - 20 000 €"},
      {"value": "20k-100k", "label": "20 000 € - 100 000 €"},
      {"value": "100k-500k", "label": "100 000 € - 500 000 €"},
      {"value": "plus-500k", "label": "Plus de 500 000 €"}
    ],
    "timelines": [
      {"value": "", "label": "Sélectionnez un délai"},
      {"value": "urgent", "label": "Urgent (moins d'1 mois)"},
      {"value": "1-3", "label": "1 à 3 mois"},
      {"value": "3-6", "label": "3 à 6 mois"},
      {"value": "6-12", "label": "6 à 12 mois"},
      {"value": "plus-12", "label": "Plus de 12 mois"}
    ],
    "afterTitle": "Ce qui se passe après votre demande",
    "afterBadge": "Et après ?",
    "afterSteps": [
      {"title": "Accusé de réception", "desc": "Vous recevez un email de confirmation avec le récapitulatif de votre demande sous 1 heure."},
      {"title": "Analyse par nos experts", "desc": "Notre équipe technique étudie votre projet et évalue la faisabilité technique."},
      {"title": "Devis détaillé", "desc": "Vous recevez un devis complet avec spécifications techniques, délais et tarifs sous 48h."},
      {"title": "Échange personnalisé", "desc": "Un chef de projet vous contacte pour discuter du devis et répondre à vos questions."}
    ],
    "faqTitle": "Questions sur les devis",
    "devisFaqs": [
      {"q": "Le devis est-il vraiment gratuit ?", "a": "Oui, absolument. L'étude de votre projet et l'établissement du devis sont entièrement gratuits et sans engagement de votre part."},
      {"q": "Sous quel délai vais-je recevoir mon devis ?", "a": "Nous nous engageons à vous transmettre un devis détaillé sous 48 heures ouvrées. Pour les projets complexes nécessitant une visite technique, le délai peut être de 5 à 7 jours."},
      {"q": "Que contient le devis ?", "a": "Le devis comprend : les spécifications techniques détaillées, la liste complète des équipements, le planning d'installation, les conditions de garantie, et le prix total détaillé."},
      {"q": "Puis-je modifier mon projet après réception du devis ?", "a": "Bien sûr ! Le devis est une base de discussion. Nos équipes sont à votre écoute pour ajuster la solution à vos besoins et contraintes."}
    ]
  },
  "about": {
    "pageTitle": "À propos d'IS TELECOM",
    "pageSubtitle": "L'histoire d'un pionnier des télécommunications en Afrique, au service de la connectivité depuis 2006",
    "missionBadge": "Notre Mission",
    "missionTitle": "Connecter l'Afrique aux réseaux de demain",
    "missionDesc1": "IS TELECOM est née en 2006 d'une vision ambitieuse : bâtir les infrastructures de télécommunication qui connectent les populations africaines au reste du monde. Depuis Cotonou, nous avons tissé un réseau de confiance avec les plus grands acteurs mondiaux de la télécommunication.",
    "missionDesc2": "Aujourd'hui partenaires de Huawei, Ericsson, MTN, Orange et bien d'autres, nous avons déployé plus de 5 000 sites de télécommunication à travers 6 pays d'Afrique. Notre expertise couvre l'ensemble de la chaîne : tours, fibre optique, maintenance et alimentation solaire des sites isolés.",
    "statCountries": "Pays desservis",
    "statProjects": "Projets réalisés",
    "statExperts": "Experts mobilisés",
    "statCapacity": "Sites de télécommunication déployés",
    "certifiedBadge": "Certifié ISO 9001",
    "certifiedSub": "Qualité garantie",
    "valuesBadge": "Nos Valeurs",
    "valuesTitle": "Ce qui nous guide au quotidien",
    "values": [
      {"title": "Connectivité Universelle", "desc": "Nous croyons que chaque communauté mérite un accès fiable aux réseaux de télécommunication, des métropoles aux villages les plus isolés."},
      {"title": "Excellence Technique", "desc": "Tous nos sites sont conformes aux normes internationales les plus strictes. Nos équipes sont formées et certifiées par Huawei, Ericsson et Nokia."},
      {"title": "Portée Internationale", "desc": "Présents dans 6 pays d'Afrique de l'Ouest et de l'Est, nous adaptons nos solutions de connectivité aux contextes locaux et aux besoins spécifiques."},
      {"title": "Innovation Continue", "desc": "Nous investissons dans les technologies de demain : 5G, IoT, edge computing et smart cities."},
      {"title": "Proximité Client", "desc": "Un accompagnement personnalisé avec un support technique NOC disponible 24h/24, 7j/7, partout en Afrique."},
      {"title": "Impact Social", "desc": "Chaque site de télécommunication que nous déployons crée des emplois locaux et ouvre l'accès à l'éducation, la santé et l'économie numérique."}
    ],
    "timelineBadge": "Notre Parcours",
    "timelineTitle": "19 ans de leadership en télécommunication",
    "timeline": [
      {"year": "2006", "title": "Création d'IS TELECOM", "desc": "Fondation de l'entreprise à Cotonou, Bénin, avec une mission claire : déployer les infrastructures de télécommunication qui connecteront l'Afrique de l'Ouest."},
      {"year": "2009", "title": "Partenariat Huawei", "desc": "Signature du premier contrat de partenariat avec Huawei Technologies pour le déploiement d'infrastructures radio en Afrique de l'Ouest. Formation de nos premières équipes certifiées."},
      {"year": "2012", "title": "Partenariat Ericsson", "desc": "IS TELECOM devient partenaire certifié d'Ericsson pour la maintenance et le déploiement d'équipements RAN (Radio Access Network). Expansion au Togo et au Mali."},
      {"year": "2015", "title": "Contrat-cadre MTN", "desc": "Signature d'un contrat-cadre pluriannuel avec MTN pour le déploiement et la maintenance de plus de 800 sites de télécommunication à travers nos 6 pays d'intervention."},
      {"year": "2019", "title": "Déploiement 4G & Fibre", "desc": "Lancement des premiers déploiements 4G/LTE et de réseaux backbone fibre optique. Plus de 2 000 sites de télécommunication en gestion active."},
      {"year": "2024", "title": "Leader panafricain", "desc": "Plus de 5 000 sites de télécommunication déployés dans 6 pays d'Afrique. Partenariats stratégiques avec Orange, Airtel, Vodacom. Certification ISO 9001 et préqualification 5G."}
    ],
    "certBadge": "Certifications",
    "certTitle": "Nos Certifications",
    "certDesc": "Des standards internationaux pour garantir la qualité et la sécurité de nos infrastructures de télécommunication",
    "certs": [
      {"label": "ISO 9001", "desc": "Qualité"},
      {"label": "Huawei Certified", "desc": "Partenaire agréé"},
      {"label": "Ericsson Certified", "desc": "RAN & Core"},
      {"label": "ISO 14001", "desc": "Environnement"}
    ]
  },
  "solutions": {
    "pageTitle": "Nos Solutions & Services",
    "pageSubtitle": "Des infrastructures de télécommunication et systèmes énergétiques sur mesure pour répondre à tous vos besoins, des tours de transmission aux projets solaires industriels",
    "processBadge": "Notre Processus",
    "processTitle": "Comment nous travaillons",
    "processSteps": [
      {"title": "Audit & Conseil", "desc": "Analyse de vos besoins techniques et étude de faisabilité sur site, qu'il s'agisse de télécommunication ou d'énergie."},
      {"title": "Conception", "desc": "Dimensionnement personnalisé avec plans d'ingénierie détaillés pour votre infrastructure."},
      {"title": "Installation", "desc": "Mise en œuvre par nos équipes certifiées, dans le respect des normes internationales."},
      {"title": "Suivi & Maintenance", "desc": "Monitoring à distance et interventions préventives garanties 24/7."}
    ],
    "ctaTitle": "Besoin d'une solution sur mesure ?",
    "ctaSubtitle": "Nos ingénieurs étudient gratuitement votre projet de télécommunication ou énergétique et vous proposent une solution adaptée à vos besoins et votre budget.",
    "ctaButton": "Demander un audit gratuit",
    "keyFeatures": "Caractéristiques clés",
    "useCases": "Cas d'usage",
    "requestQuote": "Demander un devis pour cette solution",
    "solutions": [
      {
        "title": "Tours & Pylônes Télécoms",
        "shortDesc": "Installation et maintenance de tours de télécommunication, pylônes autostables et haubanés.",
        "fullDesc": "IS TELECOM est un acteur majeur du déploiement d'infrastructures de télécommunication en Afrique. Nous concevons, fabriquons et installons des tours de télécommunication de toutes dimensions : pylônes autostables, haubanés, monopôles et mâts tubulaires. Nos équipes interviennent sur tous types de terrains, des centres urbains denses aux zones rurales les plus isolées.",
        "features": ["Pylônes autostables jusqu'à 120 mètres", "Tours haubanées pour zones à fort vent", "Monopôles urbains design et compacts", "Fondations et génie civil inclus", "Normes internationales (ANSI/TIA-222)"],
        "useCases": ["Opérateurs mobiles (MTN, Orange, Moov)", "Faisceaux hertziens", "Radiodiffusion et TV", "Énergie (éolien, monitoring)"]
      },
      {
        "title": "Réseaux Fibre Optique",
        "shortDesc": "Déploiement de réseaux fibre optique et backbone de transmission pour opérateurs de télécommunication.",
        "fullDesc": "Nous déployons des réseaux de fibre optique de bout en bout : études d'ingénierie, tirage de câbles, épissurage, tests de performance et mise en service. Nos équipes maîtrisent les technologies GPON, FTTH, et les backbones longue distance. Partenaires de référence des grands opérateurs africains.",
        "features": ["Déploiement FTTH (Fiber To The Home)", "Backbones longue distance interurbains", "Épissurage par fusion et tests OTDR", "Études d'ingénierie et avant-projets détaillés", "Maintenance et réparation de câbles endommagés"],
        "useCases": ["Réseaux métropolitains", "Connexion de sites isolés", "Data centers et hubs de télécommunication", "Campus universitaires et zones industrielles"]
      },
      {
        "title": "Maintenance & Services Télécoms",
        "shortDesc": "Maintenance préventive, curative et support technique 24/7 pour vos infrastructures de télécommunication.",
        "fullDesc": "La fiabilité de votre réseau repose sur une maintenance rigoureuse. IS TELECOM propose des contrats de maintenance sur mesure pour vos infrastructures de télécommunication : interventions préventives programmées, dépannage curatif rapide, support technique 24/7 et gestion des pièces de rechange. Nos équipes sont formées et certifiées par les plus grands équipementiers.",
        "features": ["Maintenance préventive avec planning personnalisé", "Intervention curative sous 4h (SLA garanti)", "Support technique NOC 24 heures sur 24, 7 jours sur 7", "Gestion des pièces détachées et stocks tampons", "Rapports mensuels de performance (KPI)"],
        "useCases": ["Sites de télécommunication en exploitation", "Data centers", "Stations de base radio", "Centres de commutation"]
      },
      {
        "title": "Systèmes de Micro-réseaux",
        "shortDesc": "Solutions complètes pour l'électrification rurale et urbaine avec gestion intelligente.",
        "fullDesc": "Nos systèmes de micro-réseaux sont conçus pour fournir une alimentation électrique fiable et durable dans les zones non connectées au réseau national. Chaque solution intègre des panneaux photovoltaïques, des batteries de stockage, des onduleurs intelligents et un système de monitoring centralisé.",
        "features": ["Gestion automatisée de la production et de la consommation", "Monitoring en temps réel via plateforme web et mobile", "Maintenance prédictive avec alertes automatiques", "Intégration facile avec des sources d'énergie existantes", "Tarification intelligente et gestion des abonnés"],
        "useCases": ["Villages ruraux en Afrique", "Zones péri-urbaines", "Îles isolées", "Sites industriels éloignés"]
      },
      {
        "title": "Pompage Solaire",
        "shortDesc": "Systèmes de pompage et d'irrigation solaire pour l'agriculture et l'approvisionnement en eau.",
        "fullDesc": "Nos solutions de pompage solaire transforment l'énergie du soleil en eau potable et en irrigation. Adaptées aux contextes ruraux et agricoles, elles réduisent les coûts opérationnels et assurent une disponibilité d'eau constante.",
        "features": ["Pompes submersibles haute efficacité", "Systèmes d'irrigation goutte-à-goutte intégrés", "Contrôle automatique du débit et de la pression", "Compatible avec forages profonds et puits", "Robustesse adaptée aux conditions climatiques extrêmes"],
        "useCases": ["Exploitations agricoles", "Communautés rurales", "Élevages", "Jardins botaniques"]
      },
      {
        "title": "Stockage d'Énergie",
        "shortDesc": "Solutions de stockage domestique et industrielle avec batteries lithium haute performance.",
        "fullDesc": "Le stockage est le cœur de toute installation solaire autonome. Nous proposons des solutions de batteries lithium-ion de dernière génération, avec des capacités allant du résidentiel à l'industriel, associées à des onduleurs hybrides intelligents.",
        "features": ["Batteries lithium haute densité énergétique", "Onduleurs hybrides avec commutation automatique", "Gestion intelligente du cycle de charge/décharge", "Scalabilité modulaire selon les besoins", "Garantie étendue jusqu'à 15 ans"],
        "useCases": ["Maisons individuelles", "Hôtels et resorts", "Centres de santé", "Industries"]
      },
      {
        "title": "Recharge Véhicules Électriques",
        "shortDesc": "Bornes de recharge solaire pour véhicules électriques, solutions complètes et durables.",
        "fullDesc": "Nous installons des bornes de recharge pour véhicules électriques alimentées 100% par énergie solaire. De la borne résidentielle à la station de recharge rapide publique, nous concevons des solutions adaptées à chaque besoin.",
        "features": ["Bornes de recharge rapide (jusqu'à 150 kW)", "Alimentation solaire avec stockage tampon", "Gestion des flux et optimisation tarifaire", "Monitoring de la consommation et des sessions", "Compatibilité avec tous les standards de charge"],
        "useCases": ["Parkings d'entreprises", "Stations-service", "Centres commerciaux", "Résidences collectives"]
      },
      {
        "title": "Solutions Résidentielles",
        "shortDesc": "Systèmes solaires pour maisons, hôtels et établissements de santé.",
        "fullDesc": "Nos solutions résidentielles allient performance, esthétique et simplicité. Chaque installation est sur mesure, dimensionnée selon la consommation du foyer et les contraintes du site. Installation clé en main avec maintenance incluse.",
        "features": ["Installation clé en main en 2 à 5 jours", "Maintenance préventive et curative incluses", "Garantie étendue sur équipements et main-d'œuvre", "Monitoring à distance de la production", "Autoconsommation et revente du surplus"],
        "useCases": ["Maisons individuelles", "Hôtels et guesthouses", "Cliniques et pharmacies", "Écoles et centres de formation"]
      },
      {
        "title": "Solutions Industrielles",
        "shortDesc": "Systèmes haute puissance pour zones rurales, exploitations minières et industries.",
        "fullDesc": "Pour les besoins énergétiques les plus exigeants, nous déployons des systèmes industriels haute puissance. De la mine isolée à la zone industrielle, nos solutions garantissent une alimentation fiable 24/7 avec un retour sur investissement optimisé.",
        "features": ["Capacités allant de 100 kW à plusieurs MW", "Robustesse industrielle certifiée", "Support technique 24/7 avec hotline dédiée", "Intégration hybride diesel/solaire possible", "Supervision centralisée multi-sites"],
        "useCases": ["Mines et carrières", "Zones industrielles", "Usines de fabrication", "Ports et aéroports"]
      }
    ]
  },
  "notFound": {
    "title": "Page non trouvée",
    "description": "La page que vous recherchez n'existe pas ou a été déplacée.",
    "backHome": "Retour à l'accueil"
  },
  "langSelector": {
    "fr": "Français",
    "en": "English",
    "es": "Español",
    "zh": "中文",
    "ar": "العربية"
  }
};